import request from "@/http/request"
import {
    getClassList,
    setStudentClass,
    getClassStudentList,
    exportStudent,
    getStudentViewInfo,
    publishPlanClass,
    querySignSessionList,
    querySignPlaceList,
    querySignClassList,
    getBatchSignTable,
    getPlanAllSession,
    getPlanPlaceList,
    createSignTable,
    getPlanAllSessionByPlanId,
    getPlaceSessionClassCount,
    exportClassRoomTitle,
    getClassesByPlanSessionPlace,
    getPlanPlaceSessionClass,
    exportExamOrderCode,
    getFileDeskTitle,
    judgeImportArrangeClassInfo,
    importArrangeClassInfo,
    getPreGeneratedAnswerPaper,
    downloadPreGeneratedAnswerPaper,
    exportEntrance
} from '@/http/api'

export const importArrangeClassInfoAPI = (data) => {
    return request({
        url: importArrangeClassInfo,
        isUpload:true,
        data
    })
}

export const downloadPreGeneratedAnswerPaperAPI = (data) => {
    return request({
        url: downloadPreGeneratedAnswerPaper,
        data
    })
}

export const getPreGeneratedAnswerPaperAPI = (data) => {
    return request({
        url: getPreGeneratedAnswerPaper,
        data
    })
}

export const judgeImportArrangeClassInfoAPI = (data) => {
    return request({
        url: judgeImportArrangeClassInfo,
        data
    })
}

export const getFileDeskTitleApi = (data) => {
    return request({
        url: getFileDeskTitle,
        data
    })
}

export const exportClassRoom = (data) => {
    return request({
        url: exportClassRoomTitle,
        data
    })
}

export const getClassListFn = (data) => {
    return request({
        url: getClassList,
        data
    })
}

export const setStudentClassFn = (data) => {
    return request({
        url: setStudentClass,
        data
    })
}

export const getClassStudentListFn = (data) => {
    return request({
        url: getClassStudentList,
        data
    })
}

export const exportStudentFn = (data) => {
    return request({
        url: exportStudent,
        data
    })
}

export const getStudentViewInfoFn = (data) => {
    return request({
        url: getStudentViewInfo,
        data
    })
}

export const publishPlanClassFn = (data) => {
    return request({
        url: publishPlanClass,
        data
    })
}

export const getPlaceSessionClassCountFN = (data) => {
    return request({
        url: getPlaceSessionClassCount,
        data
    })
}

export const getSignSessionList = (data) => {
    return request({
        url: querySignSessionList,
        data
    })
}
export const getSignPlaceList = (data) => {
    return request({
        url: querySignPlaceList,
        data
    })
}
export const getSignClassList = (data) => {
    return request({
        url: querySignClassList,
        data
    })
}
export const exportSign = (data) => {
    return request({
        url: getBatchSignTable,
        data
    })
}
export const getCurrentSelectSection = (data) => {
    return request({
        url: getPlanAllSession,
        data
    })
}
export const getCurrentSelectPlace = (data) => {
    return request({
        url: getPlanPlaceList,
        data
    })
}

export const getPlanAllSessionByPlan = (data) => {
    return request({
        url: getPlanAllSessionByPlanId,
        data
    })
}
export const openSignTable = (data) => {
    return request({
        url: createSignTable,
        data
    })
}
export const  getClassesByPlanSessionPlaceFn= (data) => {
    return request({
        url: getClassesByPlanSessionPlace,
        data
    })
}
export const  getPlanPlaceSessionClassFn= (data) => {
    return request({
        url: getPlanPlaceSessionClass,
        data
    })
}
export const  exportExamOrderexcel= (data) => {
    return request({
        url: exportExamOrderCode,
        data
    })
}
export const  exportEntranceFn= (data) => {
    return request({
        url: exportEntrance,
        data
    })
}